import { z } from "zod";

export const LoanTransactionSchema = z.object({
  id: z.string().uuid(),
  amount: z.string(),
  latePenalty: z.string(),
  latePenaltyPerOnDays: z.number(),
  transactionType: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  dueDate: z.string().datetime().nullable(),
  uid: z.number().nullable(),
  lastCalculateLatePenalty: z.string().nullable(),
  details: z.any().nullable(),
  createdAt: z.string().datetime(),
  paymentAt: z.string().nullable(),
  updatedAt: z.string().datetime(),
});

export type LoanTransactionType = z.infer<typeof LoanTransactionSchema>;
